import { render } from "./BlockAppUI.vue?vue&type=template&id=735e779d&scoped=true&ts=true"
import script from "./BlockAppUI.vue?vue&type=script&lang=ts"
export * from "./BlockAppUI.vue?vue&type=script&lang=ts"

import "./BlockAppUI.vue?vue&type=style&index=0&id=735e779d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735e779d"]])

export default __exports__